module.exports = __webpack_public_path__ + "img/course_bg_pc.539111bb.webp";